import '../App.css';
import '../styles/Modules.css';

export const MapArray = (arrayToMap) => {

    const divsToReturn = arrayToMap.map((item, index) => {
        <div
            className='list-line'
            key={index}>
                <span className='App-text dimTable-data dimTable-name'>{item.dimName}</span>
                
                {item.errors > 0 &&
                    <span className='App-text dimTable-data dimTable-errorCount error'>{item.errors}</span>  
                }

                {item.errors == 0 &&
                <span className='App-text dimTable-data dimTable-errorCount healthy'>HEALTHY</span>}
                
        </div>
    }) 

    return (
        {divsToReturn}
    );
}